import httpService from '@/core/http/http.service';

export class TempAccountApiClient {
    private readonly baseUrl: string = '';

    signOut(): Promise<any> {
        const apiUrl = this.baseUrl + '/api/account/impersonate';
        return httpService.delete<any>(apiUrl);
    }
}

export const TempAccountApiClientService = new TempAccountApiClient();
